import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DefaultDrawer from '../../../../../components/Drawers/Default';

const EMPTY_FILTERS = {
  name: '',
  company_name: '',
  email: '',
  phone_number: '',
  type: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({isOpen, toggle, applyFilters, filters = {}}) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({...EMPTY_FILTERS, ...filters});

  useEffect(() => {
    if (isOpen) {
      setFiltersData({...EMPTY_FILTERS, ...filters});
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return(
    <DefaultDrawer
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={filtersData.name}
            onChange={(e) => setFiltersData({...filtersData, name: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('settings.companyNameLabel')}: </Label>
          <Input 
            value={filtersData.company_name}
            onChange={(e) => setFiltersData({...filtersData, company_name: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.email')}: </Label>
          <Input 
            value={filtersData.email}
            onChange={(e) => setFiltersData({...filtersData, email: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.phone')}: </Label>
          <Input 
            value={filtersData.phone_number}
            onChange={(e) => setFiltersData({...filtersData, phone_number: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.type')}: </Label>
          <Input
            type="select"
            value={filtersData.type}
            onChange={(e) => setFiltersData({...filtersData, type: e.target.value})}
          >
            <option value="">{t('common.selectType')}</option>
            <option value="individual">{t('crm.individual')}</option>
            <option value="company">{t('crm.company')}</option>
          </Input>
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t('common.addedAfter')}</Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({...filtersData, added_after: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')}</Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({...filtersData, added_before: e.target.value})}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{marginBottom: '10px'}}>
          {t('common.filter')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.cancel')}
        </DefaultButton>
      </div>
    </DefaultDrawer>
  );
}

export default FiltersDrawer;